import {keyBy} from 'lodash-es';

import * as types from 'modulesV2/constants/canvasApp';


export default function studentQuiz(state = {byId: {}}, action) {
  switch (action.type) {
    case types.CANVAS_APP_LOAD_STUDENT_QUIZZ_SUCCESS:
      return {
        ...state,
        byId: {
          ...state.byId,
          ...keyBy(action.data, 'id')
        }
      };
    default:
      return state;
  }
}
